export default {
      id: "oc-apsara-usage",
      viewBox: "0 0 1597 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-apsara",
      toString: function () {
        return this.url;
      }
    }